module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Dashboard\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4955c7b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 446
// module chunks = 1